import {
  borderGrey,
  lighterNavy,
  lightGreyBackground,
  orange,
  red,
  white,
} from 'common/styles/colors';
import { applyErrorBorder } from 'common/styles/form';
import { CSSObjectWithLabel, GroupBase, StylesConfig } from 'react-select';
import styled from 'styled-components';

export const dropdownHeightStyling = (
  isInvalid: boolean,
): StylesConfig<unknown, false, GroupBase<unknown>> => {
  const height = 30;

  return {
    control: (base: CSSObjectWithLabel): CSSObjectWithLabel => ({
      ...base,
      '&:hover': { cursor: 'pointer' },
      height: `${height}px`,
      minHeight: `${height}px`,
      border: `${isInvalid ? `2px solid ${red}` : null}`,
    }),
    valueContainer: (base: CSSObjectWithLabel): CSSObjectWithLabel => ({
      ...base,
      height: `${height - 2}px`,
      padding: '0 6px',
    }),
    input: (base: CSSObjectWithLabel): CSSObjectWithLabel => ({
      ...base,
      margin: '0px',
    }),
    indicatorsContainer: (base: CSSObjectWithLabel): CSSObjectWithLabel => ({
      ...base,
      height: `${height - 2}px`,
    }),
  };
};

const dimensionsStyle = `
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 20px 30px 10px;
  width: 100%;
  border-radius: 8px;
`;

export const AddSettingForm = styled.form`
  ${dimensionsStyle}
  padding: 15px;
  background: ${lightGreyBackground};
  gap: 15px;

  span {
    font-family: KanitSemibold;
    color: ${lighterNavy};
  }

  button {
    border: none;
    border-radius: 4px;
    padding: 4px 15px;
  }

  .add-btn {
    border: 1px solid ${orange};
    background: ${orange};
    font-family: KanitLight;
    color: ${white};
    text-wrap: nowrap;
  }

  .cancel-btn {
    background: none;
    color: ${lighterNavy};
    border: 1px solid ${borderGrey};

    :hover {
      background: ${white};
    }
  }
`;

export const AddSettingInput = styled.input<{
  $isError: boolean;
}>`
  height: 24px;
  max-width: 150px;
  font-family: KanitSemiBold;
  font-size: 16px;
  color: ${lighterNavy};
  padding: 5px 10px;
  border: 1px solid ${borderGrey};
  border-radius: 4px;
  ${props => applyErrorBorder(props.$isError)}

  ::placeholder {
    color: ${lighterNavy};
  }
`;

export const AddSettingBtn = styled.button`
  ${dimensionsStyle}
  padding: 19px;
  border: 1px solid ${lightGreyBackground};
  background: none;
  font-family: KanitSemibold;
  font-size: 16px;
  color: ${lighterNavy};
  background: ${lightGreyBackground};

  svg {
    margin-right: 5px;
  }

  :hover {
    border: 1px solid ${orange};
  }
`;
